import { computed } from 'vue';
import { useUserStore } from "@js/vue/domain/user/stores/useUserStore";
export function useOrderStatus() {
    const userStore = useUserStore();
    // The master list of "Open" buckets defined in your PHP logic
    const OPEN_STATUS_FLOW = [
        'quotes', 'requested', 'submitted', 'processed',
        'proofs', 'revisions', 'approved', 'production',
        'printed', 'shipped'
    ];
    const STATUS_COLORS = {
        CYAN: { bg: '#00FFFF', text: '#0d1117' }, // Shipped / New Order
        MAGENTA: { bg: '#FF00FF', text: '#FFFFFF' }, // Attention Needed / Ticket
        YELLOW: { bg: '#FFFF00', text: '#0d1117' }, // In Progress / Home
        BLACK: { bg: '#000000', text: '#FFFFFF' }, // Cancelled
        GREY: { bg: '#94A3B8', text: '#FFFFFF' }, // Default
        GREEN: { bg: '#22C55E', text: '#FFFFFF' }, // Completed
        BLUE: { bg: '#3B82F6', text: '#FFFFFF' }, // Processed
    };
    const STATUS_MAP = {
        shipped: STATUS_COLORS.CYAN,
        submitted: STATUS_COLORS.MAGENTA,
        'attention-needed': STATUS_COLORS.MAGENTA, // Sync with Sidebar count badge
        requested: STATUS_COLORS.BLUE,
        production: STATUS_COLORS.YELLOW,
        approved: STATUS_COLORS.GREEN,
        cancelled: STATUS_COLORS.BLACK,
        incomplete: STATUS_COLORS.GREY,
        quotes: STATUS_COLORS.GREY,
    };
    /**
     * Replicates PHP getOpenOrderStatuses()
     * Returns the array of strings the user is permitted to interact with
     */
    const availableOpenStatuses = computed(() => {
        let statuses = [...OPEN_STATUS_FLOW];
        if (userStore.isStoreManager) {
            const hidden = ['quotes', 'proofs', 'revisions', 'approved', 'production', 'printed'];
            statuses = statuses.filter(s => !hidden.includes(s));
        }
        if (userStore.canSeeCut) {
            statuses.unshift('cut');
        }
        if (userStore.canSeeSewn) {
            statuses.unshift('sewn');
        }
        return statuses;
    });
    /**
     * Determines if a specific status should be rendered in the UI
     */
    const isStatusVisible = (status) => {
        if (!status)
            return false;
        // If it's one of the "Operational/Open" statuses, check permissions
        const operationalStatuses = ['cut', 'sewn', ...OPEN_STATUS_FLOW];
        if (operationalStatuses.includes(status)) {
            return availableOpenStatuses.value.includes(status);
        }
        // Globally Restricted: Only Admins see these
        const adminOnly = ['deleted', 'incomplete'];
        if (adminOnly.includes(status)) {
            return userStore.isAdmin;
        }
        return true;
    };
    /**
     * Returns a CSS-friendly class or color mapping
     */
    const getStatusStyle = (status) => {
        if (!status)
            return STATUS_COLORS.GREY;
        return STATUS_MAP[status.toLowerCase()] || STATUS_COLORS.GREY;
    };
    return {
        availableOpenStatuses,
        isStatusVisible,
        getStatusStyle
    };
}
